<template>
  <el-dialog
    title="选择商品"
    width="800px"
    :visible.sync="visible"
    :before-close="handleClose"
  >
    <customize-table
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :columns="columns"
      :data="dataList"
      :loading="loading"
      :pagination="pagination"
      @on-current-change="onCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-table>
  </el-dialog>
</template>

<script>
import CustomizeTable from "@/components/customize-table";
import { mapActions } from "vuex";
import Page from "@/mixin/Page";
import { pickBy, isEmpty, isNumber } from "lodash";
export default {
  components: {
    CustomizeTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  mixins: [Page],
  created() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      selectedRows: [],
      columns: [
        {
          title: "货主id",
          key: "customerId",
          align: "center"
        },
        {
          title: "商品条码",
          key: "barcodes",
          align: "center"
        },
        {
          title: "商品名称",
          key: "declareName",
          align: "center",
          width: 150
        },
        {
          title: "仓库库存",
          key: "wmsNum",
          align: "center"
        },
        {
          title: "账册库存",
          key: "stockCustomsNum",
          align: "center"
        },
        {
          title: "冻结库存",
          key: "stockFreezeNum",
          align: "center"
        }
      ],
      filterObj: {
        customerId: "",
        itemNo: ""
      }
    };
  },
  methods: {
    ...mapActions("record", ["queryList"]),
    handleClose() {
      this.$emit("close");
    },
    onCurrentChange(rows) {
      if (rows) {
        this.$emit("close");
        this.$emit("on-select", rows);
      }
    },
    getFilterParams() {
      const data = pickBy(
        this.filterObj,
        v => !isEmpty(v) || (isNumber(v) && parseInt(v))
      );
      return data;
    },
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          queryInfo: { ...filterParams },
          pageInfo: {
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        }
      };
      this.queryList(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getFormConfig() {
      return [
        {
          data: [
            {
              label: "货主",
              model: "customerId",
              type: "INPUT"
            },
            {
              label: "料号",
              model: "itemNo",
              type: "INPUT"
            }
          ]
        }
      ];
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.fetch();
      }
    }
  }
};
</script>
